import { Spacing } from '@genial/design-tokens';
import { NativeStackScreenProps } from '@react-navigation/native-stack';
import { View, ScrollView } from 'native-base';
import React from 'react';

import { SignedInRootStackParamList } from '../../routes/types';

import { DetailSection } from './components/DetailSection';
import { Header } from './components/Header';

export const ProductsManagementDetails: React.FC<
  NativeStackScreenProps<SignedInRootStackParamList, 'ProductsManagementDetails'>
> = ({ route }) => {
  return (
    <ScrollView>
      <View
        h="full"
        width="100%"
        minW="container"
        flex={1}
        px={{ base: 0, sm: Spacing['inline.sm'], lg: Spacing['inline.sm'] }}>
        <Header />
        <DetailSection routeParams={route} />
      </View>
    </ScrollView>
  );
};
